import React from 'react';

import { ProtocolAvgRatingInfo } from 'domain/types';
import { plural } from 'utils/string';

import { MarketName } from '../MarketName';
import { getRatingLabel, getResistantLabel } from './utils';
import { Join } from './Join';

export function ProtocolAvgRatingTranscription({ rating, transcription }: ProtocolAvgRatingInfo) {
  const {
    productName,
    hasBadDebtRating,
    hasManipulationComplexityRating,
    worstBadDebtMarkets,
    worstManipulationComplexityMarkets,
  } = transcription;

  if (rating.rating === 0 || rating.rating === 1) {
    const descriptions = [
      hasManipulationComplexityRating &&
        `is ${getResistantLabel(rating.rating)} to price manipulation attacks`,
      hasBadDebtRating && 'has no to little undercollateralized debt',
    ].filter(Boolean);

    return (
      <span>
        {productName} {descriptions.join(' and ')}
      </span>
    );
  }

  const mcDescription =
    worstManipulationComplexityMarkets &&
    worstManipulationComplexityMarkets.rating >= (worstBadDebtMarkets?.rating ?? 100)
      ? getWorstMarketsDescription(worstManipulationComplexityMarkets, 'of price manipulation')
      : null;
  const bdDescription =
    worstBadDebtMarkets &&
    worstBadDebtMarkets.rating >= (worstManipulationComplexityMarkets?.rating ?? 100)
      ? getWorstMarketsDescription(
          worstBadDebtMarkets,
          'due to undercollateralized debt accumulation',
        )
      : null;

  return <Join separator=". " items={[mcDescription, bdDescription]} />;
}

function getWorstMarketsDescription(
  {
    marketNames,
    rating,
  }: NonNullable<ProtocolAvgRatingInfo['transcription']['worstBadDebtMarkets']>,
  riskName: string,
) {
  return (
    <>
      {getRatingLabel(rating)} {riskName} in{' '}
      <Join
        separator=", "
        items={marketNames.slice(0, 3).map((marketName, index) => (
          <MarketName marketName={marketName} key={index} />
        ))}
      />{' '}
      {marketNames.length > 3 ? 'and other ' : null}
      {plural('market', 'markets', marketNames.length)}
    </>
  );
}
